import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[policy-type]',
    standalone: false
})
export class PolicyTypeDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}